import PrivacyConsentModal from "./PrivacyConsentModal";

export default PrivacyConsentModal;